<div
  class="ratings-group-header"
  edsFlexbox
  alignItems="flex-end"
  justifyContent="space-between"
>
  <div>
    <eds-title size="small-light">
      {{ "products.ratings-title" | translate }}
      <eds-footnote *ngIf="placement" [placement]="placement"></eds-footnote>
      <button
        class="print-hidden"
        *ngIf="tooltip"
        edsTooltip
        [analyticsName]="'products.ratings-title' | translate"
        [tooltipContent]="tooltip"
        tooltipBehavior="absolute"
        tooltipPositionDefault="bottom"
        [tooltipButton]="true"
      >
        <eds-icon type="info" size="small"></eds-icon
        ><span class="sr-only">{{ "products.ratings-title" | translate }}</span>
      </button>
    </eds-title>
    <p class="ratings-group-header__as-of-date small text-grey1">
      {{ asOfDateText }}
    </p>
  </div>
  <eds-toggle
    *ngIf="showRatingsToggle"
    class="print-hidden"
    [toggleButtons]="ratingsTypeToggle"
    (toggleActive)="onUpdate($event)"
  ></eds-toggle>
</div>
